'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Search, Building2 } from 'lucide-react';

const navLinks = [
  { label: 'Browse Directory', href: '/search-results-page' },
  { label: 'For Businesses', href: '/sign-up-login-screen' },
  { label: 'About', href: '/' },
];

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="bg-secondary border-b border-border sticky top-0 z-50 shadow-sm">
      {/* Council top bar */}
      <div className="bg-primary px-4 lg:px-8 xl:px-10 py-1.5">
        <div className="max-w-screen-2xl mx-auto flex items-center justify-between">
          <span className="text-white text-xs font-semibold tracking-wide">
            West Suffolk Council — Official Business Directory
          </span>
          <span className="text-purple-200 text-xs hidden sm:block">
            A service of West Suffolk Council
          </span>
        </div>
      </div>
      {/* Main nav */}
      <div className="px-4 lg:px-8 xl:px-10 py-3">
        <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-4">
          <Link href="/" className="flex items-center gap-3 shrink-0">
            <AppLogo size={36} />
            <div className="flex flex-col">
              <span className="text-white font-bold text-base leading-tight">
                West Suffolk
              </span>
              <span className="text-purple-200 text-xs leading-tight">
                Business Directory
              </span>
            </div>
          </Link>

          {/* Desktop search */}
          <div className="hidden md:flex flex-1 max-w-lg mx-6">
            <div className="relative w-full">
              <Search
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-purple-300"
              />
              <input
                type="search"
                placeholder="Search businesses, categories..."
                className="input-field pl-9 bg-white/10 border-white/20 text-white placeholder:text-purple-300 focus:bg-white focus:text-foreground focus:placeholder:text-muted-foreground"
              />
            </div>
          </div>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={`nav-${link?.label}`}
                href={link?.href}
                className="text-purple-100 hover:text-white text-sm font-semibold px-3 py-2 rounded transition-colors"
              >
                {link?.label}
              </Link>
            ))}
            <Link
              href="/sign-up-login-screen"
              className="btn-primary ml-2 text-sm"
            >
              <Building2 size={14} />
              List Your Business
            </Link>
          </nav>

          {/* Mobile toggle */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-secondary border-t border-white/10 px-4 pb-4">
          <div className="pt-3 pb-2">
            <div className="relative">
              <Search
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-purple-300"
              />
              <input
                type="search"
                placeholder="Search businesses..."
                className="input-field pl-9 bg-white/10 border-white/20 text-white placeholder:text-purple-300"
              />
            </div>
          </div>
          {navLinks?.map((link) => (
            <Link
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              className="block text-purple-100 hover:text-white text-sm font-semibold py-2.5 border-b border-white/10"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <Link
            href="/sign-up-login-screen"
            className="btn-primary mt-3 w-full justify-center"
            onClick={() => setMobileOpen(false)}
          >
            <Building2 size={14} />
            List Your Business
          </Link>
        </div>
      )}
    </header>
  );
}